/**
 * Модуль кнопки "Наверх"
 */

import { throttle } from '../utils/animations.js'

/**
 * Инициализирует кнопку "Наверх"
 */
export function initBackToTopButton() {
  // Создаем кнопку
  const backToTopButton = document.createElement('button')
  backToTopButton.className = 'back-to-top'
  backToTopButton.setAttribute('aria-label', 'Прокрутить наверх')
  backToTopButton.innerHTML = `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 3.75L10 16.25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.375 9.375L10 3.75L15.625 9.375" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  // Добавляем кнопку в body (раскомментируйте если нужно)
  // document.body.appendChild(backToTopButton)

  // Функция проверки положения скролла
  function checkScrollPosition() {
    if (window.pageYOffset > 300) {
      backToTopButton.classList.add('visible')
    } else {
      backToTopButton.classList.remove('visible')
    }
  }

  // Функция прокрутки наверх
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  // Обработчик для кнопки
  backToTopButton.addEventListener('click', scrollToTop)

  // Обработчик прокрутки страницы (с throttle для производительности)
  window.addEventListener('scroll', throttle(checkScrollPosition, 100))

  // Проверяем начальное положение
  checkScrollPosition()
}




